"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandUsersQueryParam = exports.brandUsersMutationKeys = exports.brandUsersQueryKeys = exports.brandEndpointIds = void 0;
exports.brandEndpointIds = {
    GET_BRAND_USERS: 'GET_BRAND_ACCOUNTS',
    DELETE_BRAND_USER: 'DELETE_BRAND_USER',
    INVITE_BRAND_USER: 'INVITE_BRAND_USER',
    UPDATE_BRAND_ROLE: 'UPDATE_BRAND_ROLE',
};
exports.brandUsersQueryKeys = {
    brandAdmins: () => ['brand', 'admins'],
    brandUsers: (filter) => ['brand', 'users', filter],
    brand: () => ['brand'],
};
exports.brandUsersMutationKeys = {
    invite: () => ['brand', 'invite'],
    remove: () => ['brand', 'remove'],
    edit: () => ['brand', 'edit'],
};
var BrandUsersQueryParam;
(function (BrandUsersQueryParam) {
    BrandUsersQueryParam["Filter"] = "filter";
})(BrandUsersQueryParam || (exports.BrandUsersQueryParam = BrandUsersQueryParam = {}));
